import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import { places } from 'sama_global/components/OlimpicTable';

const splitToSheetsByCategory = (data, intl) => {
  const categories = [];
  const categoriesObj = {};
  // Получаем массив всех категорий из data
  data.forEach(
    item =>
      !categories.includes(item.category) && categories.push(item.category)
  );

  // Создаем объект, где ключ - категория, значение - массив результатов олимпиады, отфильтрованный по нужной категории
  categories.forEach(
    c =>
      (categoriesObj[c] = XLSX.utils.json_to_sheet(
        formatResultsToExcel(
          data
            .filter(item => item.category === c)
            .sort((a, b) => b.score - a.score),
          intl
        )
      ))
  );

  return categoriesObj;
};

const formatResultsToExcel = (data, intl) => {
  const flatStages = stages => {
    const result = {};
    for (let i = 0; i < stages.length; i += 1) {
      result[`${intl.formatMessage({ id: 'stage_num' }, { stage: i + 1 })}`] =
        stages[i];
    }
    return result;
  };
  return data.map((row, i) => ({
    '#': i + 1,
    [intl.formatMessage({
      id: 'NAME',
    })]: `${row.user.name_en} ${row.user.surname_en}`,
    [intl.formatMessage({ id: 'PLACE' })]: intl.formatMessage({
      id: row.place > 3 ? 'COMPETITOR' : places[row.place] || ' ',
    }),
    [intl.formatMessage({ id: 'DATEBIRTH' })]: moment(row.user.birthday).format(
      'DD.MM.YYYY'
    ),
    [intl.formatMessage({ id: 'COUNTRY' })]: intl.formatMessage({
      id: `country.${row.country}`,
    }),
    [intl.formatMessage({ id: 'DELEGATE' })]: row.delegate,
    ...flatStages(row.result, intl),
    [intl.formatMessage({ id: 'OVERALL_SCORE' })]: row.score,
  }));
};

/* eslint-disable import/prefer-default-export */
export const downloadExcel = (data, intl) => {
  if (data.length === 0) return;

  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const fileName = intl.formatMessage({ id: 'RESULTS' });

  const workSheets = splitToSheetsByCategory(data, intl);

  const workBook = {
    Sheets: workSheets,
    SheetNames: Object.keys(workSheets),
  };

  const excelBuffer = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' });

  const eData = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(eData, fileName + fileExtension);
};
